import { useEffect, useState } from "react";
import {
    Monitor, Laptop, Smartphone, Tablet, CreditCard, Key, KeyRound, AppWindow, Printer, Headphones, Wifi, Package, Plug, Usb,
    MonitorSmartphone, Keyboard, Mouse, Camera, Server, HardDrive, Router, Cable, Watch, Speaker, Mic, Projector, Tv, Phone,
    Battery, Cpu, MemoryStick, Disc, Gamepad2, Car, Wrench, Shield, ScanLine, Radio, Lightbulb, Briefcase, Box,
} from "lucide-react";
import * as api from "../../lib/api";

// Registre d'icônes (nom lucide → composant) : une catégorie stocke le nom de son icône
export const ICON_REGISTRY = {
    Monitor, Laptop, Smartphone, Tablet, CreditCard, Key, KeyRound, AppWindow, Printer, Headphones, Wifi, Package, Plug, Usb,
    MonitorSmartphone, Keyboard, Mouse, Camera, Server, HardDrive, Router, Cable, Watch, Speaker, Mic, Projector, Tv, Phone,
    Battery, Cpu, MemoryStick, Disc, Gamepad2, Car, Wrench, Shield, ScanLine, Radio, Lightbulb, Briefcase, Box,
};
export const ICON_NAMES = Object.keys(ICON_REGISTRY);

// Repli pour les catégories natives dont la config n'aurait pas d'icône
const LEGACY_ICONS = {
    pc: "Monitor", laptop: "Laptop", smartphone: "Smartphone", tablet: "Tablet", badge: "CreditCard", license: "Key",
    software: "AppWindow", printer: "Printer", screen: "Monitor", headset: "Headphones", network_equipment: "Wifi",
    other: "Package", charger: "Plug", docking: "Usb", accessory: "Box",
};

export function iconByName(name) {
    return ICON_REGISTRY[name] || Package;
}

export function getCategoryIcon(categories, key) {
    const cat = (categories || []).find((c) => c.key === key);
    return iconByName(cat?.icon || LEGACY_ICONS[key]);
}

export function getCategoryLabel(categories, key) {
    return (categories || []).find((c) => c.key === key)?.label || key;
}

// Cache module : les catégories sont partagées entre toutes les vues de l'inventaire
let _cache = null;
let _pending = null;
const _listeners = new Set();

export async function loadInventoryCategories(force = false) {
    if (_cache && !force) return _cache;
    if (!_pending) {
        _pending = api.getInventoryCategories().then((cats) => {
            _cache = cats;
            _pending = null;
            _listeners.forEach((fn) => fn(cats));
            return cats;
        }).catch((e) => { _pending = null; throw e; });
    }
    return _pending;
}

export function useInventoryCategories() {
    const [categories, setCategories] = useState(_cache || []);
    useEffect(() => {
        _listeners.add(setCategories);
        loadInventoryCategories().then(setCategories).catch(() => {});
        return () => _listeners.delete(setCategories);
    }, []);
    return { categories, refresh: () => loadInventoryCategories(true) };
}
